import React from 'react';
import { GameConstants } from '../../../../../shared/GameConstants';
import { inputStyle, labelStyle, sectionHeaderStyle } from './styles';

interface GlobalPhysicsProps {
  onPhysicsChange: (key: string, value: number) => void;
}

export const GlobalPhysics: React.FC<GlobalPhysicsProps> = ({ onPhysicsChange }) => {
  const params = [
    { label: 'Base Gravity', key: 'GRAVITY', min: 500, max: 3000, step: 50 },
    { label: 'Fall Multiplier', key: 'FALLING_GRAVITY_MULTIPLIER', min: 1.0, max: 3.0, step: 0.1, isFloat: true },
    { label: 'Terminal Velocity', key: 'TERMINAL_VELOCITY', min: 400, max: 2000, step: 100 },
    { label: 'Air Friction', key: 'AIR_FRICTION', min: 0.90, max: 1.0, step: 0.01, isFloat: true }
  ];

  return (
    <>
      <div style={sectionHeaderStyle}>Global Physics</div>
      {params.map(p => (
        <div key={p.key} style={{ marginBottom: '15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
            <label style={labelStyle}>{p.label}</label>
            <input
              type="number"
              step={p.step}
              value={p.isFloat ? (GameConstants.Physics as any)[p.key].toFixed(2) : (GameConstants.Physics as any)[p.key]}
              style={{ ...inputStyle, width: '60px', marginBottom: 0, padding: '2px 5px', fontSize: '11px' }}
              onChange={(e) => onPhysicsChange(p.key, Number(e.target.value))}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </div>
          <input
            type="range" min={p.min} max={p.max} step={p.step}
            value={(GameConstants.Physics as any)[p.key]}
            style={{ width: '100%', margin: 0 }}
            onChange={(e) => onPhysicsChange(p.key, Number(e.target.value))}
          />
        </div>
      ))}
    </>
  );
};
